module.exports = __webpack_public_path__ + "img/备机.3a99fe8f.png";